<div *ngIf="currentSetting" style="padding-left:5px;">
	<mat-card-title>
		{{currentSetting.TITLE}}
		<help-text-btn class="align-help-text-btn" [helpTextId]="currentSetting.HELP_TEXT_ID"></help-text-btn>
	</mat-card-title>
	<mat-divider> </mat-divider>
	<br>
	<div class="row" style="position:relative;margin-left:0px;">
		<mat-card appearance="outlined" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="min-width:450px;">
			<h3 style="padding-left:18px;padding-top:5px;font-size:large;">
				Search Criteria
			</h3>
			<mat-card-content>
				<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="chosenRegions" [reset]="resetField"
					[required]="true" #appRegionCode>
				</region-dropdown-two-way>

				<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties" [reset]="resetField"
					[required]="false" #appCountyCode [regions]="chosenRegions">
				</county-dropdown-two-way>

				<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
					[reset]="resetField" [required]="false" #appDistrictCode [regions]="chosenRegions"
					[counties]="chosenCounties">
				</district-dropdown-two-way>

				<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools" [reset]="resetField"
					#appSchools [regions]="chosenRegions" [counties]="chosenCounties"
					[schoolDistricts]="chosenSchoolDistricts">
				</school-dropdown-two-way>

				<app-school-year [label]="'School Year'" [yearType]="'SchoolYear'"
					(performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0" [yearsForward]="0"
					[yearsBack]="2" [reset]="resetField" [required]="true"
					[startingSchoolYearDate]="startingSchoolYearDate" *ngIf="currentSetting.SCHOOL_YEAR">
				</app-school-year>
				<app-school-year [label]="'Performance Period'" [yearType]="'PerformancePeriod'"
					(performancePeriodEvent)="performancePeriodEvent($event)" [currentYearModifier]="0"
					[yearsForward]="0" [yearsBack]="2" [reset]="resetField" [required]="true"
					[startingSchoolYearDate]="startingSchoolYearDate" *ngIf="currentSetting.PERFORMANCE_PERIOD">
				</app-school-year>
			</mat-card-content>
			<mat-card-actions>
				<span style="padding:5px;padding-bottom:10px;">
					<span style="padding-right:15px;">
						<button mat-raised-button color="primary" mat-button
							[disabled]="!this.checkValid() || isLoading" (click)="search()">
							<mat-icon *ngIf="isLoading">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
							Search
						</button> </span>
					<span style="padding-right:15px;">
						<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
					</span>

					<span>
						<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button
							[matMenuTriggerFor]="menu" class="margin-right-xs">
							<mat-icon *ngIf="isExporting">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
							Export
							<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
						</button>
						<mat-menu #menu="matMenu">
							<button mat-menu-item (click)="downloadExcel()">
								<span>
									<i class="fa fa-file"></i>
									Export to Excel</span>
							</button>
						</mat-menu>
					</span>
				</span>
			</mat-card-actions>
		</mat-card>
	</div>

	<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>


	<div *ngIf="results.length > 0" class="margin-top-md">
		<h2>
			Search Results - {{'(' + currentSchoolYear + ')'}} - ({{(
			tableDataSource ? (tableDataSource.filteredData.length < results.length ?
				tableDataSource.filteredData.length + '/' : '' ) : '' ) + results.length}} Children) </h2>
				<hr />

				<div class="row">
					<mat-form-field>
						<mat-label>
							Filter
						</mat-label>
						<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
							(ngModelChangeDebounced)="setFilter()" />
					</mat-form-field>
				</div>

				<div class="margin-top-sm">
					<mat-table [dataSource]="tableDataSource" class="mat-elevation-z1 table-responsive fixed-layout"
						style="width:100%;" matSort>

						<ng-container matColumnDef="REGION_CODE">
							<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:70px;"> Region
							</mat-header-cell>
							<mat-cell *matCellDef="let element" style="min-width:70px;"> {{element.REGION_CODE}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_YEAR">
							<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;"> School Year
							</mat-header-cell>
							<mat-cell *matCellDef="let element" style="min-width:90px;"> {{element.SCHOOL_YEAR}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_DISTRICT">
							<mat-header-cell *matHeaderCellDef mat-sort-header> District </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.SCHOOL_DISTRICT}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_NAME">
							<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.SCHOOL_NAME}} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="CDS_CODE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> School CDS Code </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.CDS_CODE}} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="MSD_NUMBER">
							<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
							<mat-cell *matCellDef="let element">
								<edit-child-modal-btn [studentId]="element.STUDENT.ID" [type]="'string'"
									[displayText]="element.MSD_NUMBER">
								</edit-child-modal-btn>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SSID">
							<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
						</ng-container>

						<ng-container matColumnDef="LAST_NAME">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.LAST_NAME |
								titlecase}}{{(element.SECOND_LAST_NAME
								? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.FIRST_NAME |
								titlecase}}
								{{element.MIDDLE_INITIAL | titlecase}}</mat-cell>
						</ng-container>

						<ng-container matColumnDef="GRADE">
							<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:70px;"> Grade
							</mat-header-cell>
							<mat-cell *matCellDef="let element" style="min-width:70px;"> {{(element.GRADE)}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="ENROLLMENT_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;"> Enrollment Date
							</mat-header-cell>
							<mat-cell *matCellDef="let element" style="min-width:100px;"> {{element.ENROLLMENT_DATE |
								simpleDate}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="WITHDRAWAL_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;"> Withdrawal Date
							</mat-header-cell>
							<mat-cell *matCellDef="let element" style="min-width:100px;"> {{element.WITHDRAWAL_DATE |
								simpleDate}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SOURCE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Source </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.SOURCE}}
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"
							[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
							[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
							[matTooltipPosition]="'above'"
							[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
							[matTooltipClass]="'terminatedTooltip'">
						</mat-row>
					</mat-table>
				</div>
				<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
					aria-label="Select page of periodic elements">
				</mat-paginator>
	</div>
</div>